import { render, staticRenderFns } from "./musicIcon.vue?vue&type=template&id=62515196&scoped=true&"
import script from "./musicIcon.vue?vue&type=script&lang=js&"
export * from "./musicIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62515196",
  null
  
)

export default component.exports